// Botões que aparecem na linha da lista quando o ponteiro chega nela (no
// toque ficam sempre visíveis).
//
// Todos são atalho: a conversa abre clicando na linha, e lá dentro o
// cabeçalho tem as mesmas ações. Esconder um aqui não tira nada do sistema.
export const BOTOES_DA_LINHA = [
	{ id: "espiar", rotulo: "Espiar a conversa", dica: "Lê a conversa sem aceitar o atendimento." },
	{ id: "aceitar", rotulo: "Aceitar", dica: "Assume o atendimento que está esperando." },
	{ id: "transferir", rotulo: "Transferir", dica: "Passa o atendimento para outro atendente ou departamento." },
	{ id: "resolver", rotulo: "Resolver", dica: "Encerra o atendimento." },
	{ id: "ignorar", rotulo: "Ignorar", dica: "Encerra um atendimento que está esperando, sem aceitar." },
	{ id: "reabrir", rotulo: "Reabrir", dica: "Volta a abrir um atendimento já resolvido." },
	{ id: "favoritar", rotulo: "Estrela de favorito", dica: "Marca com estrela para achar depois em Favoritas." },
	{ id: "naoLida", rotulo: "Marcar como não lida", dica: "Deixa a conversa como nova, para lembrar de voltar nela." },
	{ id: "fixar", rotulo: "Fixar no topo", dica: "Prende o atendimento no alto da lista." },
];

// Ids acrescentados depois que a preferência já existia: sem isto o botão
// nasceria escondido para quem já personalizou a linha, sem ter escolhido
// escondê-lo. Mesmo cuidado de `BOTOES_NOVOS` em `botoesDaConversa.js`.
export const BOTOES_NOVOS_DA_LINHA = ["naoLida", "fixar"];

export const IDS_BOTOES_DA_LINHA = BOTOES_DA_LINHA.map((b) => b.id);
